<template>
  <div :class="badgeClass" v-bind="$attrs" v-on="$listeners">
    <span v-if="$slots.icon" :class="iconClass">
      <slot name="icon"></slot>
    </span>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "JdsBadge",
    props: {
      color: {
        type: String,
        default: "fe-text-white",
      },
      bgColor: {
        type: String,
        default: "fe-bg-marigold-40",
      },
      size: {
        type: String,
        default: "small",
        validator: (value) => ["small", "large"].includes(value),
      },
    },
    computed: {
      badgeClass() {
        return {
          "fe-inline-flex fe-items-center fe-rounded-small fe-capitalize fe-text-body-xxs-bold fe-max-w-full": true,
          "fe-px-xxs fe-py-xxxs": this.size === "small",
          "fe-px-xs fe-py-xxxs fe-text-body-s-bold": this.size === "large",
          [this.bgColor]: true,
          [this.color]: true,
        }
      },
      iconClass() {
        return {
          "fe-leading-none fe-w-base fe-pr-xxs": this.size === "small",
          "fe-leading-none fe-w-m fe-pr-xs": this.size === "large",
        }
      },
    },
  }
</script>
